import { Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Paper, Snackbar } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { UrlUtil } from "src/framework/commons/UrlUtil";
import { STATUS_CODE } from "src/framework/providers/api";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Alert } from "@material-ui/lab";
import Image from "material-ui-image";

import "./styles.scss";
import { FullWidthButton } from "src/framework/components/buttons";
import { FaCopy, FaDownload } from "react-icons/fa";

interface BaixarBoletoProperties {
    pagamentoId?: number;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const BaixarBoleto: FC<BaixarBoletoProperties> = ({
    pagamentoId,
    open,
    onClose,
    onConfirm
}) => {
    const [clipBoard, setClipBoard] = useState<{ text: string, copied: boolean }>({
        copied: false,
        text: ""
    })
    const [boleto, setBoleto] = useState<any>(null);
    const [openCopyFeedback, setOpenCopyFeedback] = useState(false);

    const downloadBoleto = (): void => {
        if (boleto) {
            UrlUtil.goto(boleto.url_download, true);
            onConfirm();
        }
    }

    const getBoleto = async (): Promise<void> => {
        if (pagamentoId) {
            const response = await pagamentoProvider.getBoleto(pagamentoId)
            if (response.statusCode === STATUS_CODE.OK) {
                setBoleto(response.data)
                setClipBoard({
                    ...clipBoard,
                    text: response.data.codigo_barras
                })
            }
        }
    }

    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenCopyFeedback(false);
    };


    useEffect(() => {
        if (open && pagamentoId) {
            getBoleto();
        }
    }, [open, pagamentoId]);

    return <div>
        <Dialog open={open} className="BaixarBoleto" maxWidth="lg">
            <DialogTitle>Baixar boleto</DialogTitle>
            <DialogContent>
                <p><strong>Importante!</strong></p>
                <Divider />
                Pague boletos apenas onde beneficiário for <strong>Intelbras 82.901.000/0001-27 Rodovia BR 101, KM 210 - 88104-800 - SAO JOSE. </strong>
                <p>Boletos da Intelbras começam com <strong>341</strong>.</p>
                <Paper elevation={0} >
                    <Image src={`${window.location.origin}/boleto-intelbras.png`}
                        aspectRatio={5}
                    />
                </Paper>
                <Divider />
                <DialogContentText>
                    Utilize as ações abaixo para copiar o código do boleto ou baixar boleto.
                </DialogContentText>
            </DialogContent>
            <div className="row actions">
                <div className="X12 M4 X--order3 M--order1">
                    <FullWidthButton
                        onClick={() => {
                            onClose();
                        }}
                        text="Fechar"
                    />
                </div>
                <div className="X6 M4 X--order2 M--order2">
                    <CopyToClipboard text={clipBoard.text}
                        onCopy={() => {
                            setClipBoard({ ...clipBoard, copied: true })
                            setOpenCopyFeedback(true);
                        }}>
                        <FullWidthButton
                            color="secondary"
                            variant="outlined"
                            disableElevation
                            onClick={() => { }}
                            startIcon={<><FaCopy /></>}
                            text="Copiar código"
                        />

                    </CopyToClipboard>
                </div>
                <div className="X6 M4 X--order1 M--order3">
                    <FullWidthButton
                        text="Baixar Boleto"
                        color="primary"
                        variant="contained"
                        disableElevation
                        startIcon={<><FaDownload /></>}
                        onClick={() => {
                            downloadBoleto();
                        }}
                    />

                </div>
            </div>
            {/* <DialogActions className="actions">
                <Button
                    onClick={() => {
                        onClose();
                    }}
                >
                    Fechar
                </Button>
                <CopyToClipboard text={clipBoard.text}
                    onCopy={() => {
                        setClipBoard({ ...clipBoard, copied: true })
                        setOpenCopyFeedback(true);
                    }}>
                    <Button
                        color="secondary"
                        variant="outlined"
                        disableElevation
                        onClick={() => {

                        }}
                    >
                        Copiar código
                    </Button>
                </CopyToClipboard>
                <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={() => {
                        downloadBoleto();

                    }}
                >
                    Baixar Boleto
                </Button>
            </DialogActions> */}

        </Dialog>
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={openCopyFeedback}
            autoHideDuration={3000}
            onClose={handleClose}
        >
            <Alert onClose={handleClose} severity="success" variant="filled">Copiado!</Alert>
        </Snackbar>
    </div>
}

export { BaixarBoleto }